'use client'

import Image from 'next/image'
import type { FC } from 'react'
import styles from './DeleteAddressSnackbar.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { getImageUrl } from '@/tools/image-service/client'
import { Button, ButtonVariants, Snackbar } from '@/tools/ui'

interface Props {
  onClose: () => void
  onConfirmDelete: () => void
}

// TODO: delete snackbar when no longer using iframe WEBX-461

export const DeleteAddressSnackbar: FC<Props> = ({
  onClose: handleClose,
  onConfirmDelete: handleConfirmDelete,
}) => {
  const { t } = useLocalisation()

  const rubbishIcon = (
    <Image
      alt="Delete icon"
      height={75}
      src={getImageUrl({
        source: 'dh:/customer-assets-glovo/address_flow/address_book/address_deletion.svg',
      })}
      width={128}
    />
  )

  const confirmDeleteButton = (
    <Button
      label={t('common.delete')}
      variant={ButtonVariants.critical}
      onClick={handleConfirmDelete}
    />
  )

  return (
    <Snackbar
      actionButton={confirmDeleteButton}
      className={styles.snackbar}
      closeButtonAriaLabel={t('common.delete')}
      dismissible={true}
      label={`${t('address-details.delete-modal.title')}. ${t('address-details.delete-modal.body')}.`}
      leadingAccessory={rubbishIcon}
      onDismiss={handleClose}
    />
  )
}
